module.exports = __webpack_public_path__ + "img/enabled.0ac2bedc.svg";